export default "__VITE_ASSET__BdVblbtL__"